import { defineStore } from "pinia";
import Vue from "vue";

export const Store = defineStore("main", {
  state: () => {
    return {
      navList: [], // 导航条
      globalConfig: {}, // 全局配置
      linkList: [], // 公司/友情链接
      isMobile: false, // 是否是手机端
    };
  },
  getters: {
    // 筛选类型为公司地址的链接
    companyLink() {
      return this.linkList.filter((ele) => ele.linkType == 1);
    },
    // 筛选类型为友情链接的链接
    friendLink() {
      return this.linkList.filter((ele) => ele.linkType == 0);
    },
  },
  actions: {
    setIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile = !!flag;
    },
    // 存储导航条
    setNavList(data) {
      this.navList = data;
    },
    // 存储全局配置
    async setConfig() {
      let res = await Vue.prototype.$api.getConfig();
      this.globalConfig = res.data;
    },
    // 存储友情链接
    setFriendLink(data) {
      this.linkList = data;
    },
  },
});
